<ng-container *ngIf="menuDefinition$ | async as menuDefinition; else loading">
  <ng-container *ngFor="let item of menuDefinition.items">
    <a
      [communityMenuItem]="item"
      [itemActiveClass]="'active-link'"
      mat-ripple
      [class]="getSidebarLinkClass(item)"
      [class.disabled]="isDisabled(item)"
      [attr.aria-disabled]="isDisabled(item)"
      [attr.data-test-id]="'navigation-' + item.link"
    >
      <mat-icon>{{ item.icon }}</mat-icon>
      <span> {{ item.text | translate }}</span>
    </a>
  </ng-container>
</ng-container>
<ng-template #loading>
  <div class="loading">
    <trp-spinner [diameter]="60"></trp-spinner>
  </div>
</ng-template>
